import { render, staticRenderFns } from "./RoleDistribution.vue?vue&type=template&id=23a7c5b7&scoped=true&"
import script from "./RoleDistribution.vue?vue&type=script&lang=js&"
export * from "./RoleDistribution.vue?vue&type=script&lang=js&"
import style0 from "./RoleDistribution.vue?vue&type=style&index=0&id=23a7c5b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7c5b7",
  null
  
)

export default component.exports